const eaglesNarrativeSections = [
  {
    heading: 'One More Night at Sphere',
    paragraphs: [
      'A year after seeing U2 open up the possibilities of Sphere, we went back during AWS re:Invent 2024 to see what another legendary band would do with the room.',
      'This time it was the Eagles, and the group had grown: Marcus, Brandon A., Brandon L., Jasmine and Steve, Ben, Al, Matt, and me.',
      'U2 had made Sphere feel like a technological revelation. The Eagles made it feel like a complete show. Their production was less interested in demonstrating the building than in giving nearly every song its own world.',
    ],
  },
  {
    heading: 'Dinner Had Other Plans',
    paragraphs: [
      'Before the concert, we had dinner at Estiatorio Milos. It was exactly the kind of meal that makes it easy to lose track of time: a large group, great seafood, and no natural moment when anyone wanted to be the person who said we needed to leave.',
      'Our tickets said 8:30 p.m. Dinner kept going anyway.',
      'By the time we reached Sphere, the Eagles were already playing. We passed the Eagles displays in the lobby and hurried upward, knowing the opening song was happening somewhere beyond the concourse walls.',
    ],
  },
  {
    heading: 'Hotel California Was Already Playing',
    paragraphs: [
      'We entered the seating bowl in the middle of "Hotel California." Missing the beginning was painful, but walking into Sphere while that song was already unfolding was also a dramatic way to arrive.',
      'A desert highway stretched around the room before the imagery shifted toward the song\'s darker mythology: the giant eagle, the hotel, and a banquet scene suspended in time.',
      'There was no slow introduction to the scale of the place. We stepped inside and were immediately surrounded by one of the most recognizable songs ever recorded.',
    ],
  },
  {
    heading: 'Section 406, Row 13',
    paragraphs: [
      'Our seats were in Section 406, Row 13, high enough that a conventional arena might have made the band feel distant.',
      'At Sphere, height is an advantage. From the 400 level we could see the stage, but we could also take in the entire dome as one composition. The images did not stop behind the band. They climbed over us and wrapped around the audience.',
      'The Eagles themselves sometimes looked small below, but the show never did.',
    ],
  },
  {
    heading: 'The Screen Served the Songs',
    paragraphs: [
      'The crowd felt older, slower, and more relaxed than the U2 audience the year before. There was less restless energy and more of a sense that everyone had come to settle in with songs they had known for decades.',
      'That mood suited the production. The sound was remarkably clean, especially the stacked harmonies, and the visuals rarely fought for attention. They built an atmosphere around each song, then changed completely when the next one began.',
      'U2 had shown us what Sphere could do. The Eagles seemed to understand how to use it consistently.',
    ],
  },
  {
    heading: 'Written Across the Sky',
    paragraphs: [
      'During "Lyin\' Eyes," handwritten lyrics rose through the darkness and drifted toward the stars, turning a familiar story into something that felt both intimate and enormous.',
      '"Take It to the Limit" expanded into planets, nebulas, and fields of stars. "Witchy Woman" moved through moss-covered trees, while "Peaceful Easy Feeling" opened into night skies and birds in flight.',
      'None of those treatments needed a complicated plot. Each one took the emotional temperature of the song and extended it all the way across the room.',
    ],
  },
  {
    heading: 'In the City',
    paragraphs: [
      'The most convincing transformation came during "In the City." Sphere first became a canyon of black-and-white tenement buildings, every window and fire escape stretching upward around us.',
      'Then the city began to bend. The walls curled inward until the streets seemed to form a towering cylinder, collapsed into a tiny planet, and finally gave way to a green natural world.',
      'From Section 406, we could see the complete illusion. It was one of those rare Sphere moments when the room appeared to change shape even while you knew your seat had not moved.',
    ],
  },
  {
    heading: 'A Career Across the Walls',
    paragraphs: [
      'For "New Kid in Town," filmstrips, amplifiers, guitars, and archival images assembled around the band like a three-dimensional scrapbook.',
      '"The Boys of Summer" placed swimmers underwater, suspended above and around the audience. "Life in the Fast Lane" turned the room into a drive through Las Vegas, letting speed, neon, and the Strip carry the song forward.',
      'The visual language kept changing, but the idea stayed consistent: use the entire building to reveal a different side of music everyone already knew.',
    ],
  },
  {
    heading: 'The Encore',
    paragraphs: [
      'The encore moved through "Take It Easy," Joe Walsh\'s "Rocky Mountain Way," "Desperado," and "Heartache Tonight." During "Rocky Mountain Way," magenta and orange light streaked through the dome like a tunnel. For "Desperado," an orchestra appeared behind a grand curtain, giving the ballad the scale of a finale.',
      'Then came an unexpected December addition: "Please Come Home for Christmas," making its tour debut that night.',
      'When the final Eagles title appeared against the stars, the room felt less like a screen going dark than a world closing around the last note.',
    ],
  },
  {
    heading: 'What the Eagles Understood About Sphere',
    paragraphs: [
      'The U2 show remains unforgettable because it was our first experience inside Sphere. It showed us the building\'s impossible scale and how easily it could disrupt your sense of space.',
      'The Eagles show was better integrated. Instead of saving the biggest ideas for a handful of showcase moments, it gave song after song a visual identity: desert highway, handwritten sky, cosmic distance, twisting city, underwater swimmers, Las Vegas at speed, and a curtain rising behind "Desperado."',
      'It was still an Eagles concert first. The visuals supported the music, the crowd settled into the songs, and Sphere became the setting rather than the headline.',
      'That may be why it felt like the more complete use of the building. U2 showed us the possibilities. The Eagles made those possibilities feel natural.',
    ],
  },
  {
    heading: 'The Set',
    paragraphs: [
      'The December 6 show covered the band\'s catalog, Don Henley and Joe Walsh solo favorites, and one Christmas surprise.',
    ],
  },
];

const eaglesSetListSections = [
  {
    heading: 'Main Set',
    items: [
      'Hotel California',
      'One of These Nights',
      'Lyin\' Eyes',
      'Take It to the Limit',
      'Witchy Woman',
      'Peaceful Easy Feeling',
      'Tequila Sunrise',
      'In the City',
      'I Can\'t Tell You Why',
      'New Kid in Town',
      'Seven Bridges Road',
      'Those Shoes',
      'Life\'s Been Good',
      'Already Gone',
      'The Boys of Summer',
      'Life in the Fast Lane',
    ],
  },
  {
    heading: 'Encore',
    items: [
      'Take It Easy',
      'Rocky Mountain Way',
      'Desperado',
      'Heartache Tonight',
      'Please Come Home for Christmas',
    ],
  },
];

export default eaglesNarrativeSections.flatMap((section) => (
  section.heading === 'The Set' ? [section, ...eaglesSetListSections] : [section]
));
